import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { RegionalSettings } from '../presentationalComponents/RegionalSettings';
import { dispatchFetchAvailableModalitiesV2, dispatchUpdatePreferredLocale, dispatchUpdatePreferredTimeZone } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getTheme } from '../styles/themes';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    isRegionalSettingsEnabled: state.ContactState.ModalitySectionState.isRegionalSettingsEnabled,
    timeZones: state.ContactState.ModalitySectionState.timeZones,
    supportedLanguages: state.ContactState.ModalitySectionState.supportedLanguages,
    preferredTimeZone: state.ContactState.ModalitySectionState.preferredTimeZone,
    preferredLocale: state.ContactState.ModalitySectionState.preferredLocale,
    theme: getTheme(state),
  };
};

const mapDispatchToProps = {
  dispatchUpdatePreferredLocale,
  dispatchUpdatePreferredTimeZone,
  dispatchFetchAvailableModalitiesV2,
};

export const RegionalSettingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegionalSettings);
